module.exports = __webpack_public_path__ + "static/media/info-heading.33bf3093.png";